// The 11 Master Hubs mapped 1-for-1 to the locked backend registry.
// `key` MUST match the registered tool name in the backend registry.
// `primaryParam` is the field the main terminal text populates by default.

export const USER_ID = "founder_1";

export const HUBS = [
  {
    key: "social_hub", index: "01", label: "Social", sub: "Feeds & public posts",
    icon: "Share2", primaryParam: "message",
    ops: ["create_post", "get_feed", "like", "comment", "set_visibility", "follow"],
  },
  {
    key: "imagery_hub", index: "02", label: "AI Imagery", sub: "9:16 staging crops",
    icon: "Image", primaryParam: "prompt",
    ops: ["generate_image", "composite", "comic", "style", "photo_pack"],
  },
  {
    key: "video_hub", index: "03", label: "AI Video", sub: "Slideshow & welds",
    icon: "Video", primaryParam: "topic",
    ops: ["generate_reel", "ad_pipeline", "lyric_reel", "animate", "faceless_reel"],
  },
  {
    key: "music_hub", index: "04", label: "AI Music", sub: "Track sync layers",
    icon: "Music", primaryParam: "lyrics",
    ops: ["generate_song", "lofi", "voice_memo", "mistbeat"],
  },
  {
    key: "writing_hub", index: "05", label: "AI Writing", sub: "Scripts & OCR notes",
    icon: "PenLine", primaryParam: "text",
    ops: ["write_script", "article", "poetry", "caption", "translate"],
  },
  {
    key: "career_hub", index: "06", label: "Career", sub: "Roadmap profiles",
    icon: "Briefcase", primaryParam: "resume_text",
    ops: ["analyze_resume", "milestone", "profile_map", "service_request"],
  },
  {
    key: "wealth_hub", index: "07", label: "Wealth / Money", sub: "Wallet ledger loops",
    icon: "Wallet", primaryParam: "note",
    ops: ["get_wallet", "credit", "debit", "ledger", "tax_report"],
  },
  {
    key: "lifestyle_hub", index: "08", label: "Lifestyle", sub: "Intake & timeline",
    icon: "HeartPulse", primaryParam: "entry",
    ops: ["log_food", "get_journal", "save_recipe", "parse_inspiration"],
  },
  {
    key: "rewards_hub", index: "09", label: "Grow / Rewards", sub: "Daily free-spin",
    icon: "Gift", primaryParam: null,
    ops: ["spin", "create_goal", "advance_goal", "get_streak", "leaderboard"],
  },
  {
    key: "business_hub", index: "10", label: "Business Tools", sub: "B2B background ops",
    icon: "Building2", primaryParam: "rule_text",
    ops: ["create_asset", "list_assets", "add_rule", "list_rules", "b2b_task"],
  },
  {
    key: "account_hub", index: "11", label: "Account", sub: "Avatar & metadata",
    icon: "UserCircle", primaryParam: "value",
    ops: ["get_profile", "update_profile", "set_avatar", "add_memory", "get_memory",
      "list_memories", "create_reminder", "list_reminders", "register_asset", "storage_overview"],
  },
];

export const getHub = (key) => HUBS.find((h) => h.key === key);
